module.exports = __webpack_public_path__ + "static/media/image-card-8.d3ec646f.png";